var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 64,
    viewBox: "0 0 50 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0056 39.8794C25.0924 39.877 25.1619 39.8059 25.1619 39.7186C25.1619 39.6298 25.0899 39.5578 25.0011 39.5578C24.9123 39.5578 24.8403 39.6298 24.8403 39.7186C24.8403 39.8059 24.9099 39.877 24.9967 39.8794L25.0011 39.8793L25.0056 39.8794Z",
    fill: "#3B4B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43832 23.1558V16.5628C8.43832 7.41543 15.8537 0 25.0011 0C34.1485 0 41.5639 7.41543 41.5639 16.5628V23.1558H43.0112C46.4748 23.1558 49.2825 25.9636 49.2825 29.4271V57.7286C49.2825 61.1922 46.4748 64 43.0112 64H6.99108C3.5275 64 0.719727 61.1922 0.719727 57.7286V29.4271C0.719727 25.9636 3.52751 23.1558 6.99108 23.1558H8.43832ZM13.2624 16.5628C13.2624 10.0797 18.518 4.82412 25.0011 4.82412C31.4842 4.82412 36.7398 10.0797 36.7398 16.5628V23.1558H13.2624V16.5628ZM25.0011 34.7337C22.248 34.7337 20.0162 36.9655 20.0162 39.7186C20.0162 41.5967 21.0548 43.2322 22.589 44.0821V50.01C22.589 51.3421 23.6689 52.4221 25.0011 52.4221C26.3332 52.4221 27.4131 51.3421 27.4131 50.01V44.0822C28.9474 43.2323 29.9861 41.5968 29.9861 39.7186C29.9861 36.9655 27.7542 34.7337 25.0011 34.7337Z",
    fill: "#3B4B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockV2);
export default __webpack_public_path__ + "static/media/lock-v2.af433435361f4bd87325766af7461bd4.svg";
export { ForwardRef as ReactComponent };